import React, { Fragment } from 'react'
import { Card, CardBody, Col, Container, Row, Button,Input } from 'reactstrap';
import { ModalPrecodedText } from '../../components/precodedTexts/ModalPrecodedText';
import { usePrecodedText } from '../../hooks/precodedTexts/usePrecodedText';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';

export const IndexPrecodedTexts = ({ activeTab }) => {
    const {
        precodedTexts, typePrecodedTexts, method,
        id_type_precoded_text, text, handleInputChange, validaciones,
        toggle, modal, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleSearch, handleClearPrecoded, handleExportPrecoded,
        loadingExport, searchTypePrecoded,
        showDeleteAlert, modalAlert, closeDeleteAlert

    } = usePrecodedText({ activeTab });

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_precoded_text)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_precoded_text)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                 <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                    <TitleDataTable
                                        titleTable="Listado de textos precodificados"
                                        buttonActions={handleExportPrecoded}
                                        titleButton="Excel de tipos de muestras"
                                        isDisbled={loadingExport}
                                        loadingIsDisabled={loadingExport}
                                        titleCreate="Crear texto precodificado"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearch}
                                        valueFilter={searchTypePrecoded}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearPrecoded}

                                    />
                                </Col>                            
                                  
                                <DataTable 
                                    value={precodedTexts} 
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[10, 20, 50]} 
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    responsiveLayout="scroll"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img 
                                                src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} 
                                                style={{ width: "25%" }} 
                                                alt="Sin resultados" 
                                            />
                                            <br />
                                            <p className='badge badge-light-primary mt-2' style={{fontSize: "15px"}}>
                                                No hay coincidencias con la búsqueda.
                                            </p>
                                        </div>
                                    }
                                    >

                                    <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                    <Column field="type_name" header="Tipo de texto precodificado"  headerStyle={headerStyle} style={centerStyle} />
                                    <Column field="text" header="Nombre"  headerStyle={headerStyle} style={centerStyle} />

                                    <Column header="Acciones" body={actions}exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                </DataTable>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ModalPrecodedText
                {...{ modal, toggle, loading, method, id_type_precoded_text, text, typePrecodedTexts, handleInputChange, validaciones, saveCreate, saveUpdate, saveDelete }}
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar texto precodificado"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el texto precodificado?"
                    alert1={true}
                    titleAlert1={text}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />
            )}
        </Fragment>
    )
}
